import React, { useEffect, useState } from "react";
import { api, API_BASE } from "@/lib/api";

// Renders authenticated images: fetches as blob and creates an object URL,
// because <img> tags cannot send Authorization headers.
export default function AuthImage({ path, alt = "", className = "", style, "data-testid": testId }) {
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    if (!path) return undefined;
    let cancelled = false;
    let url = null;
    (async () => {
      try {
        const resp = await api.get(`/files/${path}`, { responseType: "blob" });
        if (cancelled) return;
        url = URL.createObjectURL(resp.data);
        setBlobUrl(url);
      } catch (e) {
        if (!cancelled) setBlobUrl(null);
      }
    })();
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [path]);

  if (!path) return null;
  if (!blobUrl) {
    return (
      <div
        className={`bg-[#141414] animate-pulse ${className}`}
        style={style}
        data-testid={testId || "auth-image-loading"}
      />
    );
  }
  return <img src={blobUrl} alt={alt} className={className} style={style} data-testid={testId || "auth-image"} />;
}

export { API_BASE };
